import React from 'react';
import { default as MainContent } from './PortalHome';
import { AgentLayout as Layout, ListResources } from '../../components/Portal';

const resources: any[] = [
  // Removed w.r.f new comments NIWC-1945 dated August 26, 2022
  // Reverted w.r.f comment 4. NIWC-2029 dated September 26, 2022
  {
    redirect: 'https://vimeo.com/showcase/9783672',
    title: 'Approved Agent Training Videos',
    description: 'Videos walking you through the most successful tried and tested sales approaches.',
    imageUrl: '/images/portal/img-agent-training-videos.jpg'
  },
  // Removed w.r.f point 3 task# NIWC-1945
  // {
  //     redirect: 'https://vimeo.com/showcase/8741782',
  //     title: "Approved Agent Training Guides",
  //     description: "Helpful documentation you can refer to for selling NIW products and services.",
  //     imageUrl: "/images/portal/img-training-guides.jpg"
  // }
]

export default () => {
  return (
    <Layout>
      <MainContent
        title="Agent Training"
        description="Resources to ensure your success selling NIW products and services."
      >
        <ListResources resources={resources} />
      </MainContent>
    </Layout>
  )
}
